import { render } from "./SubmissionModal.vue?vue&type=template&id=1ecdd73f"
import script from "./SubmissionModal.vue?vue&type=script&lang=js"
export * from "./SubmissionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__